// extracted by mini-css-extract-plugin
export default {"mCard":"YE-z","image":"ZE-z","imageNoBackground":"_E-z","imageHasCategory":"aF-z","fullWidth":"bF-z"};